export default __webpack_public_path__ + "static/media/Pit Crew.208a3450.png";